import type { TextStyleValue } from '@elfsight/configurator-contracts';

export const commonFieldsSettings = {
  fieldActiveColor: 'rgb(25, 123, 255)',
  fieldActiveFillColor: undefined as string | undefined,
  fieldLabelPosition: 'outside' as 'inside' | 'outside',
  fieldHeadingColor: 'rgb(17, 17, 17)',
  fieldInsideLabelColor: 'rgba(17, 17, 17, 0.5)',
  fieldLabelColor: 'rgb(17, 17, 17)',
  fieldColor: 'rgb(17, 17, 17)',
  fieldHintColor: 'rgba(17, 17, 17, 0.5)',
  fieldFillColor: 'rgba(17, 17, 17, 0.1)',
  fieldBorderType: null,
  fieldBorderWidth: 1,
  fieldBorderRadius: 4,
  fieldBorderColor: 'rgba(17, 17, 17, 0.2)',
  fieldHeadingFontStyle: {
    fontSize: 20,
    fontWeight: 'bold',
    fontStyle: 'normal',
    textTransform: undefined
  } as TextStyleValue,
  fieldInsideLabelFontStyle: {
    fontSize: 15,
    fontWeight: 'normal',
    fontStyle: 'normal',
    textTransform: undefined
  } as TextStyleValue,
  fieldLabelFontStyle: {
    fontSize: 15,
    fontWeight: 'bold',
    fontStyle: 'normal',
    textTransform: undefined
  } as TextStyleValue,
  fieldFontStyle: {
    fontSize: 15,
    fontWeight: 'normal',
    fontStyle: 'normal'
  } as TextStyleValue,
  fieldHintFontStyle: {
    fontSize: 13
  } as TextStyleValue,
  fieldSpacing: 20
};

export type CommonFieldsSettings = typeof commonFieldsSettings;
